import React from 'react';
import Page from '../components/Page';
import { FormattedMessage } from 'react-intl';

const Vulnerabilidade = (props) => {
   return(
      <Page bg="/assets/img/vulnerabilidade-bg.jpg">
         <h1><FormattedMessage id="vulnerabilidade.h1"/></h1>
         <p><FormattedMessage id="vulnerabilidade.p1"/></p>
         <h3><FormattedMessage id="vulnerabilidade.h3_1"/></h3>
         <p><FormattedMessage id="vulnerabilidade.p2"/></p>
         <h3><FormattedMessage id="vulnerabilidade.h3_2"/></h3>
         <p><FormattedMessage id="vulnerabilidade.p3"/></p>
      </Page>
   )
}

export default Vulnerabilidade;